// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1ZaCf","name":"ConsentHeader_name__3_ZCd","birthday":"ConsentHeader_birthday__25Yrh","skeleton":"ConsentHeader_skeleton__3xi--"};